import HENGE from "@henge-inc/global-types";
import HUI from "@henge-inc/ui/v1_2";
import React, { useState } from "react";

export type SliderControllerProps = {
  value: number;
  setValue: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  showTick?: boolean;
};

export const SliderController = ({
  value,
  setValue,
  min = 0,
  max = 100,
  step = 1,
  showTick = false,
}: SliderControllerProps) => {
  const roundedValue = Math.round(value * 10) / 10;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(Number(e.target.value));
  };

  const [hover, setHover] = useState(false);

  const getPercentage = (value: number): number => {
    return ((value - min) / (max - min)) * 100;
  };

  const generateTicks = () => {
    const ticks = [];
    const numSteps = (max - min) / step;

    for (let i = 1; i < numSteps; i++) {
      const tickValue = min + i * step;

      const percentage = getPercentage(tickValue);

      ticks.push(
        <div
          key={i}
          className="absolute w-px h-2 -translate-x-1/2 bg-[var(--gray200)]"
          style={{ left: `${percentage}%` }}
        />,
      );
    }
    return ticks;
  };

  return (
    <div
      className="relative w-full"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div
        className="w-full h-6 rounded-[8px] overflow-hidden relative flex items-center transition-colors"
        style={{
          backgroundColor: hover ? "var(--gray50)" : "var(--gray50-alpha40)",
        }}
      >
        <div
          className="h-full transition-colors"
          style={{
            backgroundColor: hover ? "var(--gray900)" : "var(--gray800)",
            width: `${getPercentage(roundedValue)}%`,
          }}
        />
        {showTick && (
          <div className="absolute w-full h-full flex justify-center items-center pointer-events-none">
            {generateTicks()}
          </div>
        )}
        <HUI.Text
          kind={HENGE.TEXT_KIND.small}
          colour={HENGE.SEMANTIC_TEXT_COLOUR["text-caption"]}
          weight={HENGE.TEXT_WEIGHT.semibold}
          className="absolute right-2 select-none"
        >
          {roundedValue}
        </HUI.Text>
      </div>

      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={roundedValue}
        onChange={handleChange}
        className="absolute top-0 left-0 w-full h-6 opacity-0 cursor-ew-resize"
      />
    </div>
  );
};
